"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Signal = void 0;
var Signal = /** @class */ (function () {
    function Signal() {
        this.subs = [];
    }
    Signal.prototype.on = function (fn) {
        this.subs.push(fn);
        return this;
    };
    Signal.prototype.once = function (fn) {
        var _this = this;
        var wrap = function (arg) {
            _this.off(wrap);
            fn.call(null, arg);
        };
        this.subs.push(wrap);
        return this;
    };
    Signal.prototype.off = function (fn) {
        if (fn) {
            var idx = this.subs.indexOf(fn);
            if (idx !== -1) {
                this.subs.splice(idx, 1); // only remove one
            }
        }
        else {
            this.subs.length = 0; // truncate
        }
        return this;
    };
    Signal.prototype.emit = function (arg) {
        this.subs.slice().forEach(function (s) { return s.call(null, arg); });
        return this;
    };
    Signal.prototype.event = function (arg) {
        var _this = this;
        setTimeout(function () { return _this.emit(arg); }, 0);
        return this;
    };
    return Signal;
}());
exports.Signal = Signal;
